module.exports = __webpack_public_path__ + "img/ct-rating.c8a62f79.png";